import React from "react";
import style from "./style.scss";

import { Tooltip as ReactTooltip } from "react-tooltip";

export const Tooltip = ({ id, place = "top" }) => {
    return <ReactTooltip className={style.base} id={id} place={place} effect="solid" />;
};
